// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-form-viewer-business-unit-select .fi-form-viewer-business-unit-select-wrapper {
  border: 1px solid var(--fi-color-extra-light);
  border-radius: 4px;
  padding: 18px 23px;
  margin-top: 25px;
}
.fi-form-viewer-business-unit-select .fi-form-viewer-business-unit-select-wrapper .heading,
.fi-form-viewer-business-unit-select .fi-form-viewer-business-unit-select-wrapper .message {
  font-size: 16px;
  line-height: 18px;
}
.fi-form-viewer-business-unit-select .fi-form-viewer-business-unit-select-wrapper .heading {
  margin: 0 0 8px 0;
}
.fi-form-viewer-business-unit-select .fi-form-viewer-business-unit-select-wrapper .mat-mdc-form-field {
  width: 100%;
}

.form-business-unit-select .mat-mdc-option .mdc-list-item__primary-text .check-icon {
  margin-right: 10px;
  transition: all 0.2s;
  opacity: 1;
}
.form-business-unit-select .mat-mdc-option .mdc-list-item__primary-text .check-icon.transparent {
  opacity: 0;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-form-shared/fi-form-viewer/fi-form-viewer-business-unit-select/fi-form-viewer-business-unit-select.component.scss"],"names":[],"mappings":"AACI;EACI,6CAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAAR;AAEQ;;EAEI,eAAA;EACA,iBAAA;AAAZ;AAGQ;EACI,iBAAA;AADZ;AAIQ;EACI,WAAA;AAFZ;;AAUY;EACI,kBAAA;EACA,oBAAA;EACA,UAAA;AAPhB;AASgB;EACI,UAAA;AAPpB","sourcesContent":[".fi-form-viewer-business-unit-select {\r\n    .fi-form-viewer-business-unit-select-wrapper {\r\n        border: 1px solid var(--fi-color-extra-light);\r\n        border-radius: 4px;\r\n        padding: 18px 23px;\r\n        margin-top: 25px;\r\n\r\n        .heading,\r\n        .message {\r\n            font-size: 16px;\r\n            line-height: 18px;\r\n        }\r\n\r\n        .heading {\r\n            margin: 0 0 8px 0;\r\n        }\r\n\r\n        .mat-mdc-form-field {\r\n            width: 100%;\r\n        }\r\n    }\r\n}\r\n\r\n.form-business-unit-select {\r\n    .mat-mdc-option {\r\n        .mdc-list-item__primary-text {\r\n            .check-icon {\r\n                margin-right: 10px;\r\n                transition: all 0.2s;\r\n                opacity: 1;\r\n\r\n                &.transparent {\r\n                    opacity: 0;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
